import { EventSettings } from './types';

/**
 * Dados padrão do Congresso de Homens IPCC 2026.
 * Tudo aqui pode ser sobrescrito pelo Painel Administrativo (Firestore: settings/homens2026).
 * Fonte: preletores/CRONOGRAMA CONGRESSO 2026.docx
 */
export const DEFAULT_SETTINGS: EventSettings = {
  eventName: 'Congresso de Homens',
  eventEdition: 'IPCC 2026',
  eventVerse: 'Vigiai, estai firmes na fé, portai-vos varonilmente e fortalecei-vos.',
  eventVerseRef: '1 Coríntios 16:13',

  eventDate: '16 a 18 de Outubro',
  eventYear: '2026',
  eventTime: 'Chegada sexta às 18h45, direto na Chácara',
  eventPrice: 0,
  paymentInfo: 'Pague por PIX ou diretamente na igreja, até o dia 09/10, parcelado em até duas vezes.',

  locationName: 'Igreja Presbiteriana Central de Cascavel',
  locationAddress: 'Rua Sete de Setembro, 2870 - Cascavel - PR',
  retreatName: 'Chácara Renovare',
  retreatAddress: 'Av. Brasil, 4 - Pacaembu, Cascavel - PR',
  retreatNotes: [
    '🚗 Chegada na sexta direto na Chácara, a partir das 18h45, com jantar na sequência.',
    '🛏️ Leve roupa de cama, toalha e itens de higiene (veja a lista completa acima).',
    '🔥 Culto da Fogueira no sábado à noite e retorno à Igreja no domingo às 9h.'
  ],
  // O endereço puro não acha o ponto certo no Maps; usamos o embed e o pin por coordenadas
  retreatMapEmbed: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3616.2475201415773!2d-53.3107429239618!3d-24.991703977843827!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94f180ad8cfec51d%3A0x572a8375eea13842!2sChacara%20Renovare%20IPCC!5e0!3m2!1spt-BR!2sbr!4v1789512837903!5m2!1spt-BR!2sbr',
  retreatMapsLink: 'https://www.google.com/maps/search/?api=1&query=Chacara%20Renovare%20IPCC%2C%20Av.%20Brasil%2C%204%20-%20Pacaembu%2C%20Cascavel%20-%20PR',

  speakers: [
    {
      id: 'jeremias',
      name: 'Pr. Jeremias Pereira',
      title: 'Pastor',
      image: '/preletores/jeremias-pereira-v2.webp',
      sessions: 'Sábado • Domingo'
    },
    {
      id: 'marcel',
      name: 'Marcel Souza',
      title: 'Universidade da Família (UDF)',
      image: '/preletores/marcel-souza.webp',
      sessions: 'Sexta • Sábado • Domingo'
    },
    {
      id: 'ednaldo',
      name: 'Pr. Ednaldo Batista Ribeiro',
      title: 'Pastor',
      image: '/preletores/ednaldo-batista-ribeiro.webp',
      sessions: 'Sábado'
    }
  ],

  schedule: [
    {
      id: 'sexta',
      label: 'Sexta-feira',
      date: '16 de Outubro',
      place: 'Chácara Renovare',
      items: [
        { time: '18h45', activity: 'Chegada e check-in', who: 'direto na Chácara Renovare', icon: '🚪' },
        { time: '19h30', activity: 'Louvor e Ministração', who: 'Pastor Leo e Marcel (UDF)', icon: '🎸' },
        { time: '21h30', activity: 'Jantar', icon: '🍽️' },
        { time: '23h00', activity: 'Descanso', icon: '🌙' }
      ]
    },
    {
      id: 'sabado',
      label: 'Sábado',
      date: '17 de Outubro',
      place: 'Chácara Renovare',
      items: [
        { time: '6h00', activity: 'Alvorada', icon: '🌅' },
        { time: '6h20', activity: 'Louvor e Devocional', who: 'Pr. Ednaldo', icon: '📖' },
        { time: '7h30', activity: 'Café da manhã', icon: '☕' },
        { time: '8h10', activity: 'Culto da Manhã', who: 'Marcel', icon: '🎤' },
        { time: '10h00', activity: 'Circuito', who: 'Coordenação Sonny', icon: '🏃' },
        { time: '13h00', activity: 'Almoço — Costelão', icon: '🍖' },
        { time: '16h00', activity: 'Palavra', who: 'Pr. Jeremias', icon: '🎤' },
        { time: '17h30', activity: 'Bate-papo em grupos', icon: '💬' },
        { time: '19h30', activity: 'Jantar', icon: '🍽️' },
        { time: '21h00', activity: 'Louvor', icon: '🎸' },
        { time: '22h00', activity: 'Palavra', who: 'Pr. Jeremias', icon: '🎤' },
        { time: '23h00', activity: 'Culto da Fogueira', icon: '🔥' }
      ]
    },
    {
      id: 'domingo',
      label: 'Domingo',
      date: '18 de Outubro',
      place: 'Chácara Renovare → Igreja (IPCC)',
      items: [
        { time: '6h30', activity: 'Alvorada', icon: '🌅' },
        { time: '7h00', activity: 'Devocional', who: 'Marcel', icon: '📖' },
        { time: '8h00', activity: 'Café da manhã', icon: '☕' },
        { time: '9h00', activity: 'Retorno para a Igreja', icon: '🚌' },
        { time: '10h00', activity: 'Culto de Encerramento na Igreja', who: 'Pr. Jeremias', icon: '⛪' }
      ]
    }
  ],

  checklist: [
    'Bíblia',
    'Lençol de solteiro',
    'Travesseiro e fronha',
    'Cobertor',
    'Toalha de banho',
    'Itens de higiene pessoal (sabonete, shampoo, escova dental etc.)',
    'Muda de roupa para sujar',
    'Protetor solar',
    'Squeeze (garrafa) para água',
    'Repelente',
    'Lanterna',
    'Material para anotações'
  ],

  pixKey: '78.118.353/0001-88',
  pixReceiver: 'Igreja Presbiteriana Central',
  pagSeguroEmail: 'eventos@ipcc.com.br',
  pagSeguroToken: '',
  pagSeguroSandbox: false,
  pauseAutomaticPayments: true,

  contactWhatsApp: '44999690123',
  isRegistrationClosed: false
};

/** O que está incluso na inscrição (exibido na landing page). */
export const INCLUDES = [
  { icon: '🏕️', title: 'HOSPEDAGEM', description: 'Duas noites na Chácara Renovare, em meio à natureza, longe da correria.' },
  { icon: '🍖', title: 'COSTELÃO E REFEIÇÕES', description: 'Jantar de sexta, café, almoço com costelão e jantar de sábado, café de domingo.' },
  { icon: '🎤', title: 'MINISTRAÇÕES', description: 'Palavra, devocionais e cultos com Marcel Souza, Pr. Jeremias e Pr. Ednaldo.' },
  { icon: '🔥', title: 'CULTO DA FOGUEIRA', description: 'Sábado à noite, ao redor do fogo: louvor, oração e comunhão entre irmãos.' },
  { icon: '🏃', title: 'CIRCUITO', description: 'Atividades e desafios em equipe para quebrar o gelo e forjar amizades.' },
  { icon: '💬', title: 'BATE-PAPO EM GRUPOS', description: 'Conversas francas entre homens sobre fé, família, trabalho e propósito.' }
];
